module.exports = __webpack_public_path__ + "static/media/question-square.9cf5012d.svg";